// src/utils/helpers.js

/**
 * Generates a short, random alphanumeric ID.
 * @returns {string} A short ID.
 */
export const generateShortId = () => {
    return Math.random().toString(36).substring(2, 9);
};
